// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 12px;
  padding: 16px;
}

.mini-card {
  background: #1f1f2e;
  color: white;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.2s ease;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

.mini-card:hover {
  transform: translateY(-4px) scale(1.03);
  background: #2a2a40;
}

.mini-icon {
  font-size: 22px;
  margin-bottom: 6px;
}

.mini-title {
  font-size: 12px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/minicard/minicard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sDAAsD;EACtD,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".mini-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: 12px;\n  padding: 16px;\n}\n\n.mini-card {\n  background: #1f1f2e;\n  color: white;\n  border-radius: 12px;\n  padding: 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.15s ease, background 0.2s ease;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n}\n\n.mini-card:hover {\n  transform: translateY(-4px) scale(1.03);\n  background: #2a2a40;\n}\n\n.mini-icon {\n  font-size: 22px;\n  margin-bottom: 6px;\n}\n\n.mini-title {\n  font-size: 12px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
